module.exports = __webpack_public_path__ + "static/OpenSans-SemiBoldItalic-fc17ea62c914b2aaa9e89ecc519a8cb3.ttf";